import React from 'react';
import { Col, Input, Label, Row, FormGroup } from 'reactstrap';
import PropTypes from 'prop-types';
import Area from '../addbooking/Area';
import { useLocaleConfig } from '../../../context/AppContext';
import Appbutton from '../../common/AppButton';

export default function SectionOne({
  formData,
  handleChange,
  preferredTimeSlots,
  onLocationSelect,
  onSubmit,
  loading,
}) {
  SectionOne.propTypes = {
    formData: PropTypes.object,
    handleChange: PropTypes.func,
    preferredTimeSlots: PropTypes.array,
    onLocationSelect: PropTypes.func,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool,
  };

  const { taxMode, getAmountWithTax, formatCurrency } = useLocaleConfig();

  return (
    <Row className="quote-form-row">
      {/* Phone Number */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="phone">Phone Number</Label>
          <Input
            disabled
            name="phone"
            id="phone"
            type="number"
            value={formData?.phone || ''}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Name */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-name">
            Name <small className="text-danger">*</small>
          </Label>
          <Input
            id="eq1-name"
            disabled
            type="text"
            name="name"
            value={formData?.name || ''}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Link Address */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-link">Link Address</Label>
          <Input
            id="eq1-link"
            value={formData?.link || ''}
            onChange={handleChange}
            name="link"
            type="text"
          />
        </FormGroup>
      </Col>

      {/* Preferred Date */}
      <Col lg={3} sm={12}>
        <Label for="eq1-prefered-date">
          Preferred Date: <small className="text-danger">*</small>
        </Label>
        <Input
          id="eq1-prefered-date"
          type="date"
          name="prefered_date"
          className="form-control"
          value={formData?.prefered_date}
          onChange={handleChange}
        />
      </Col>
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-prefered-time">
            Preferred Time <small className="text-danger">*</small>
          </Label>
          <Input
            id="eq1-prefered-time"
            type="select"
            value={formData?.prefered_time || ''}
            name="prefered_time"
            onChange={handleChange}
          >
            <option value="">Select Preferred Time</option>

            {preferredTimeSlots?.map((preferredTimeSlot) => (
              <option
                key={preferredTimeSlot.id}
                value={preferredTimeSlot.id}
              >
                {preferredTimeSlot.time_zone}
              </option>
            ))}
          </Input>
        </FormGroup>
      </Col>

      {/* Latitude & Longitude */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="latlong">
            Latitude & Longitude{' '}
            <small className="text-danger">*</small>
          </Label>
          <Input
            value={formData?.latlong || ''}
            onChange={handleChange}
            name="latlong"
            id="latlong"
          />
        </FormGroup>
      </Col>

      {/* City + Area */}
      <Area
        initialCity={formData?.city || ''}
        initialArea={formData?.area || ''}
        onSelect={(latlong) =>
          handleChange({
            target: {
              name: 'latlong',
              value: latlong,
            },
          })
        }
        onLocationSelect={onLocationSelect}
      />

      {/* Near By */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-near-by">Near By</Label>
          <Input
            id="eq1-near-by"
            type="text"
            value={formData?.near_by || ''}
            name="near_by"
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Payment Mode */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="payment-mode">
            Payment Mode <small className="text-danger">*</small>
          </Label>

          <Input
            type="select"
            name="payment_mode"
            id="payment-mode"
            value={formData?.payment_mode || ''}
            onChange={handleChange}
          >
            <option value="">Select Payment Method</option>
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="credit_card">Credit Card</option>
              <option value="debit_card">Debit Card</option>
              <option value="net_banking">Net Banking</option>
          </Input>
        </FormGroup>
      </Col>

      {/* House No / Villa No */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-house-no">
            H.No
          </Label>

          <Input
            id="eq1-house-no"
            type="text"
            name="house_no"
            value={formData?.house_no || ''}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Booking Notes */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-note">Booking Notes</Label>

          <textarea
            id="eq1-note"
            className="form-control"
            name="note"
            rows="3"
            value={formData?.note || ''}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Address */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-address">Address</Label>

          <textarea
            className="form-control"
            name="address"
            id="eq1-address"
            rows="3"
            value={formData?.address || ''}
            onChange={handleChange}
          />
        </FormGroup>
      </Col>

      {/* Booking Status */}
      <Col lg={3} sm={12}>
        <FormGroup>
          <Label htmlFor="eq1-booking-status">
            Booking Status{' '}
            <small className="text-danger">*</small>
          </Label>

          <Input
            type="select"
            name="booking_status"
            id="eq1-booking-status"
            value={formData?.booking_status || 'confirmed'}
            onChange={handleChange}
          >
            <option value="confirmed">Confirmed</option>
            <option value="uncertain">Uncertain</option>
            <option value="delayed">Delayed</option>
          </Input>
        </FormGroup>
      </Col>

      {/* Submit */}
      <Col
        lg={3}
        sm={12}
        className="quote-submit-col"
        style={{ paddingTop: '26px' }}
      >
        <Appbutton
          type="button"
          className="btn btn-primary quote-submit-btn"
          onClick={onSubmit}
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </Appbutton>
      </Col>

      {/* Cost Summary */}
      <Col lg={12} sm={12}>
        <div className="quotation-services-summary">
          <strong>Total Price: {formatCurrency(formData?.total_price || 0)}</strong>
          <strong>
           Total With {taxMode}: {formatCurrency(Number(getAmountWithTax(formData?.total_price || 0).toFixed(2)))}
          </strong>
        </div>
      </Col>
    </Row>
  );
}
